module.exports = __webpack_public_path__ + "static/media/advisor-1.a9b3dbfa.jpg";